<template>
    <div >
        <section class="ch-gw-page-banner" :style="{backgroundImage:'url('+ urls.lxwm +')'}" style="padding-top: 25rem;">
     
    </section>
    <!-- ====== Banner End ====== -->

    <!-- ====== Contact Start ====== -->
    <section id="contact" class="ch-gw-contact ch-gw-animation">
      <div class="container ">
        <div class="row align-items-center">
          
          <div style="width: 100%;">
            <div class="ch-gw-contact-form-wrapper"  style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;padding-left: 1rem;padding-right: 1rem;padding-top: 2rem;padding-bottom: 2rem;">
              <div class="gw_contact_text">
                <div style="width: 40%;"><img :src="urls.logols"  alt="logo" /></div>
                <div style="padding-top: 1rem;padding-right: 1rem;">
                  <p style="padding-left: 0.5rem;padding-top: 1rem;font-size: 0.9rem;" v-for="(item,index) in homeBottoms.homeBottomInfoList" v-if="item.phone != null">{{ item.phone }}</p>
                  <p style="padding-left: 0.5rem;padding-top: 1rem;font-size: 0.9rem;" v-for="(item,index) in homeBottoms.homeBottomInfoList" v-if="item.address != null">{{ item.address }}</p>
                </div>
              </div>
              <div class="gw_contact_ewm" >
                <div style="width: 40%;margin: 0 auto;"><img :src="homeBottoms.src" alt="logo" /></div>
                <span>微信公众号</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
</template>

<script>
import { queryHomeSubmitData } from "@/utils/gw";
export default {
  name: 'contact',
  data () {
    return {
      msg: '首页',
		  homeBottoms:{},
      urls:{
        lxwm: require('@/assets/ch/lxwm.jpg'),
        ewm: require('@/assets/ch/ewm.jpg'),
        logols: require('@/assets/ch/ls-chjt+logo.png'),
      }
    }
  },
  mounted() {
    this.queryHomeSubmitData();
  },
  methods:{
    queryHomeSubmitData(){
			queryHomeSubmitData().then((e)=>{
        e.data.homeBottoms[0].src = e.data.homeBottoms[0].src.replaceAll("/dev-api","")
				this.homeBottoms = e.data.homeBottoms[0]
        console.log(this.homeBottoms)
			})
		},	
  }
}
</script>


// WEBPACK FOOTER //
// src/components/contact.vue